import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
  Button,
} from "reactstrap";
import Select from "react-select";
import * as Yup from "yup";
import { useFormik } from "formik";
import { NameSurname, Status } from "./contactlistCol";
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import axios from "axios";
import "jspdf-autotable";
import {
  getJob_Advertisement as onGetJob_Advertisement,
  addBolge as onAddBolge,
  updateJob_Advertisement as onUpdateJob_Advertisement,
  deleteJob_Advertisement as onDeleteJob_Advertisement,
} from "store/contacts/actions";
import { isEmpty } from "lodash";
import { useSelector, useDispatch } from "react-redux";

const ContactsList = (props) => {
  const tableRef = useRef(null);
  document.title = "İlçe Bölgeler | Süvari Kurye ADMIN PANELI";

  const dispatch = useDispatch();

  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();
  const [getIsActive, setIsActive] = useState(false); // This state seems unused in your current validation onSubmit

  // State for District/Neighborhood Management Modal
  const [districtModal, setDistrictModal] = useState(false);
  const [selectedRegionForDistrict, setSelectedRegionForDistrict] = useState(null);
  const [istanbulDistricts, setIstanbulDistricts] = useState([]);
  const [associatedDistricts, setAssociatedDistricts] = useState([]); // Bu state, o bölgeye bağlı olan ve listelenen ilçeleri tutar.

  // New states for center neighborhood and extra fee (for the form fields)
  const [selectedDistrictForForm, setSelectedDistrictForForm] = useState(null); // Formdaki seçilen ilçe (Select kutusunun değeri)
  const [selectedDistrictNeighborhoods, setSelectedDistrictNeighborhoods] = useState([]); // Seçili ilçenin mahalleleri
  const [centerNeighborhood, setCenterNeighborhood] = useState(null); // Merkez mahalle Select'in değeri
  const [extraFee, setExtraFee] = useState(""); // Ekstra ücret input'unun değeri
  const [isEditDistrictDetails, setIsEditDistrictDetails] = useState(false); // İlçe detayları düzenleme modunda mı?

  // State for Region Transition Definition Modal
  const [regionTransitionModal, setRegionTransitionModal] = useState(false);
  const [sourceRegion, setSourceRegion] = useState(null);
  const [targetRegion, setTargetRegion] = useState(null);
  const [transitionFee, setTransitionFee] = useState("");
  const [regionTransitions, setRegionTransitions] = useState([]);

  // Validation schema for BolgeAdi in the main modal
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      BolgeAdi: contactEdit ? contactEdit.BolgeAdi : "",
    },
    validationSchema: Yup.object({
      BolgeAdi: Yup.string().required("Bölge Adı zorunludur."),
    }),
    onSubmit: async (values) => {
      if (isEdit) {
        const nodeupdateUser = {
          ID: contactEdit.ID,
          BolgeAdi: values.BolgeAdi,
        };
        dispatch(onUpdateJob_Advertisement(nodeupdateUser));
      } else {
        const newUser = {
          BolgeAdi: values.BolgeAdi,
        };
        dispatch(onAddBolge(newUser));
      }
      setIsEdit(false);
      validation.resetForm();
      toggle();
    },
  });

  const { users } = useSelector((state) => ({
    users: state.contacts.jobadvertisement,
  }));

  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
      {
        Header: "Bölge Başlık",
        accessor: "BolgeAdi",
        filterable: true,
        Cell: (cellProps) => {
          return <NameSurname {...cellProps} />;
        },
      },
      {
        Header: "Bağlı İlçeler",
        accessor: "Ilceler",
        Cell: (cellProps) => (
          <>
            {cellProps.value ? cellProps.value.length : 0}
          </>
        ),
      },
      {
        Header: "İşlemler",
        Cell: (cellProps) => {
          const userData = cellProps.row.original;
          return (
            <div className="d-flex gap-3">
              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  handleUserClick(userData);
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Düzenle
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-primary"
                onClick={() => {
                  handleDistrictManagementClick(userData);
                }}
              >
                <i className="mdi mdi-map-marker-plus font-size-18" id="adddistricttooltip" />
                <UncontrolledTooltip placement="top" target="adddistricttooltip">
                  İlçe Yönetimi
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  onClickDelete(userData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  useEffect(() => {
    if (users && !users.length) {
      dispatch(onGetJob_Advertisement());
      setIsEdit(false);
    }
  }, [dispatch, users]);

  useEffect(() => {
    setContact(users);
  }, [users]);

  useEffect(() => {
    if (!isEmpty(users) && !!isEdit) {
      setContact(users);
    }
  }, [users]);

  // Fetch Istanbul Districts on component mount
  useEffect(() => {
    const fetchIstanbulDistricts = async () => {
      try {
        const response = await axios.get('https://adminsuvari.stechomeyazilim.info:8765/getProviencesNameSuvari/istanbul');
        console.log("lksmdf",response.data.data[0])
        setIstanbulDistricts(response.data.data[0].districts.map(d => ({ label: d.name, value: d.id })));
      } catch (error) {
        console.error("Error fetching Istanbul districts:", error);
      }
    };
    fetchIstanbulDistricts();
  }, []);

  // Fetch Region Transitions from backend on component mount
  useEffect(() => {
    const fetchRegionTransitions = async () => {
      try {
        const response = await axios.get('https://adminsuvari.stechomeyazilim.info:8765/getBolgeGecisUcretleri/select');
        const mappedTransitions = response.data.map(transition => {
          const source = users.find(u => u.ID === transition.KaynakBolgeID);
          const target = users.find(u => u.ID === transition.HedefBolgeID);
          return {
            id: transition.ID,
            source: source ? source.BolgeAdi : 'Bilinmiyor',
            target: target ? target.BolgeAdi : 'Bilinmiyor',
            fee: transition.Ucret,
            KaynakBolgeID: transition.KaynakBolgeID,
            HedefBolgeID: transition.HedefBolgeID,
          };
        });
        setRegionTransitions(mappedTransitions);
      } catch (error) {
        console.error("Error fetching region transitions:", error);
        setRegionTransitions([]);
      }
    };

    if (users.length > 0) {
      fetchRegionTransitions();
    }
  }, [users]);

  const toggle = () => {
    setModal(!modal);
  };

  const handleUserClick = (arg) => {
    const user = arg;
    setEditContact(user);
    setIsEdit(true);
    validation.setValues({ BolgeAdi: user.BolgeAdi });
    toggle();
  };

  // --- District/Neighborhood Management functions ---
  const toggleDistrictModal = () => {
    setDistrictModal(!districtModal);
    // Modal kapatıldığında veya açıldığında form alanlarını sıfırla
    setSelectedDistrictForForm(null);
    setSelectedDistrictNeighborhoods([]);
    setCenterNeighborhood(null);
    setExtraFee("");
    setIsEditDistrictDetails(false); // Modu sıfırla
  };

  const fetchAssociatedDistricts = async (regionId) => {
    try {
      const response = await axios.get(`https://adminsuvari.stechomeyazilim.info:8765/getIlcelerByBolgeId/${regionId}`);
      setAssociatedDistricts(response.data.map(d => ({
        label: d.IlceAdi,
        value: d.ID, // İlçe ID'si
        MerkezMahalleID: d.MerkezMahalleID,
        MerkezMahalleAdi: d.MerkezMahalleAdi,
        MerkezDisiEkUcret: d.MerkezDisiEkUcret
      })));
    } catch (error) {
      console.error("Error fetching associated districts:", error);
      setAssociatedDistricts([]);
    }
  };

  const handleDistrictManagementClick = (regionData) => {
    setSelectedRegionForDistrict(regionData);
    fetchAssociatedDistricts(regionData.ID);
    toggleDistrictModal();
  };

  // İlçe Seç Select kutusundan bir ilçe seçildiğinde (yeni veya mevcut)
  const handleSelectDistrictForForm = async (selectedOption) => {
    setSelectedDistrictForForm(selectedOption); // Formdaki Select'in değerini ayarla

    console.log("Selected district for form:", selectedOption);
    if (selectedOption) {
      try {
        
        

        const response = await axios.get(`https://adminsuvari.stechomeyazilim.info:8765/getDistrictsSuvari/${selectedOption.value}`);
        setSelectedDistrictNeighborhoods(response.data.data.neighborhoods.map(n => ({ label: n.name, value: n.id })));

        // Seçilen ilçe, listedeki mevcut bir ilçe mi kontrol et
        const existingDistrictInAssociated = associatedDistricts.find(d => d.value === selectedOption.value);

        if (existingDistrictInAssociated) {
          // Mevcut bir ilçe ise, detaylarını form alanlarına yükle ve düzenleme moduna geç
          setCenterNeighborhood(existingDistrictInAssociated.MerkezMahalleID ? { label: existingDistrictInAssociated.MerkezMahalleAdi, value: existingDistrictInAssociated.MerkezMahalleID } : null);
          setExtraFee(existingDistrictInAssociated.MerkezDisiEkUcret !== undefined ? existingDistrictInAssociated.MerkezDisiEkUcret.toString() : "");
          setIsEditDistrictDetails(true); // Düzenleme moduna geç
        } else {
          // Yeni bir ilçe ise, form alanlarını temizle ve ekleme moduna geç
          setCenterNeighborhood(null);
          setExtraFee("");
          setIsEditDistrictDetails(false); // Ekleme moduna geç
        }
      } catch (error) {
        console.error("Error fetching district neighborhoods:", error);
        setSelectedDistrictNeighborhoods([]);
        setCenterNeighborhood(null);
        setExtraFee("");
        setIsEditDistrictDetails(false); // Hata durumunda ekleme moduna geç
      }
    } else {
      // Select kutusu boşaltıldığında, tüm alanları sıfırla ve ekleme moduna geç
      setSelectedDistrictNeighborhoods([]);
      setCenterNeighborhood(null);
      setExtraFee("");
      setIsEditDistrictDetails(false);
    }
  };

  // Eklenen İlçeler listesinden bir ilçe tıklandığında (doğrudan düzenleme için)
 const handleEditDistrictFromList = async (districtData) => {
    // 1. Üstteki Select kutusunu tıklanan ilçe ile doldur
    setSelectedDistrictForForm({ label: districtData.label, value: districtData.value });

    // 2. Tıklanan ilçenin mahallelerini çek ve Merkez Mahalle Seç'i doldur
    try {
       // İlk API çağrısı: İlçe adına göre ID'yi al
       const responseNew = await axios.get(
           `https://adminsuvari.stechomeyazilim.info:8765/getDistrictsNameSuvari/${districtData.label}`,
           { timeout: 10000 } // 10 saniye zaman aşımı
       );

       // İlk API yanıtını kontrol et
       if (!responseNew.data || !responseNew.data.data || responseNew.data.data.length === 0 || !responseNew.data.data[0].id) {
           console.warn(`İlk API çağrısı geçersiz yanıt döndü veya ilçe ID bulunamadı. İlçe Adı: ${districtData.label}`);
           // Geçersiz veri durumunda formu sıfırla ve düzenleme modundan çık
           setSelectedDistrictNeighborhoods([]);
           setCenterNeighborhood(null);
           setExtraFee("");
           setIsEditDistrictDetails(false);
           return; // Fonksiyondan çık, ikinci isteği gönderme
       }

       const districtId = responseNew.data.data[0].id;

       console.log("İlçe ID'si:", districtId);
       // İkinci API çağrısı: İlçe ID'sine göre mahalleleri ve diğer bilgileri al
       const response = await axios.get(
           `https://adminsuvari.stechomeyazilim.info:8765/getDistrictsSuvari/${districtId}`,
           { timeout: 10000 } // 10 saniye zaman aşımı
       );

       console.log("API Yanıtı:", response.data);

       // Yanıtın beklenen yapıda olduğunu kontrol et
       if (!response.data || !response.data.data || !response.data.data.neighborhoods) {
           console.warn("İkinci API çağrısı geçerli mahalle verisi döndürmedi.");
           setSelectedDistrictNeighborhoods([]);
           setCenterNeighborhood(null);
           setExtraFee("");
           setIsEditDistrictDetails(false);
           return;
       }

       setSelectedDistrictNeighborhoods(response.data.data.neighborhoods.map(n => ({ label: n.name, value: n.id })));

       // 3. Tıklanan ilçenin merkez mahalle ve ekstra ücret bilgilerini form alanlarına yükle
       setCenterNeighborhood(districtData.MerkezMahalleID ? { label: districtData.MerkezMahalleAdi, value: districtData.MerkezMahalleID } : null);
       setExtraFee(districtData.MerkezDisiEkUcret !== undefined ? districtData.MerkezDisiEkUcret.toString() : "");
       setIsEditDistrictDetails(true); // Düzenleme moduna geç

    } catch (error) {
       console.error("İlçe detayları çekilirken hata oluştu:");
       if (axios.isCancel(error)) {
           console.error('İstek zaman aşımına uğradı:', error.message);
       } else if (error.response) {
           // Sunucudan yanıt geldi ama hata kodu döndü (4xx, 5xx)
           console.error('Sunucu hata ile yanıt verdi - Durum Kodu:', error.response.status, 'Veri:', error.response.data);
       } else if (error.request) {
           // İstek gönderildi ama yanıt alınamadı (ağ hatası, sunucu kapalı vb.)
           console.error('Sunucudan yanıt alınamadı. Ağ bağlantınızı veya sunucuyu kontrol edin:', error.request);
       } else {
           // Diğer hatalar (örn: kodda bir hata)
           console.error('Beklenmeyen bir hata oluştu:', error.message);
       }

       setSelectedDistrictNeighborhoods([]);
       setCenterNeighborhood(null);
       setExtraFee("");
       setIsEditDistrictDetails(false); // Hata durumunda ekleme moduna dön veya formu sıfırla
    }
  };


  const handleAddDistrictWithDetails = async () => {
    if (!selectedDistrictForForm || !centerNeighborhood || extraFee === "") {
      alert("Lütfen bir ilçe, merkez mahalle ve ekstra ücret girin.");
      return;
    }

    const payload = {
      IlceAdi: selectedDistrictForForm.label,
      IlAdi: "İstanbul",
      Bolgeler_ID: selectedRegionForDistrict.ID,
      MerkezMahalleID: centerNeighborhood.value,
      MerkezMahalleAdi: centerNeighborhood.label,
      MerkezDisiEkUcret: parseFloat(extraFee),
    };

    try {
      if (isEditDistrictDetails) {
        // Düzenleme modundaysa PUT isteği gönder
        await axios.patch(`https://adminsuvari.stechomeyazilim.info:8765/patchIlceler/${selectedDistrictForForm.value}`, payload);
        alert(`İlçe "${selectedDistrictForForm.label}" başarıyla güncellendi!`);
      } else {
        // Ekleme modundaysa POST isteği gönder
        await axios.post('https://adminsuvari.stechomeyazilim.info:8765/postIlceler/send', payload);
        alert(`İlçe "${selectedDistrictForForm.label}" başarıyla eklendi!`);
      }

      dispatch(onGetJob_Advertisement());
      fetchAssociatedDistricts(selectedRegionForDistrict.ID);
      // Form alanlarını sıfırla ve yeni ilçe ekleme moduna geç
      setSelectedDistrictForForm(null);
      setSelectedDistrictNeighborhoods([]);
      setCenterNeighborhood(null);
      setExtraFee("");
      setIsEditDistrictDetails(false); // Yeni ilçe ekleme moduna dön
    } catch (error) {
      console.error("Error adding/updating district with details:", error);
      alert("İlçe eklenirken/güncellenirken bir hata oluştu.");
    }
  };

  const handleRemoveDistrict = async (districtId) => {
    try {
      await axios.delete(`https://adminsuvari.stechomeyazilim.info:8765/deleteIlce/${districtId}`);
      alert("İlçe başarıyla silindi.");
      fetchAssociatedDistricts(selectedRegionForDistrict.ID);
      dispatch(onGetJob_Advertisement());
      // Silinen ilçe formda seçili ise formu temizle
      if (selectedDistrictForForm && selectedDistrictForForm.value === districtId) {
        setSelectedDistrictForForm(null);
        setSelectedDistrictNeighborhoods([]);
        setCenterNeighborhood(null);
        setExtraFee("");
        setIsEditDistrictDetails(false);
      }
    } catch (error) {
      console.error("Error deleting district:", error);
      alert("İlçe silinirken bir hata oluştu.");
    }
  };

  // --- Region Transition Definition functions ---
  const toggleRegionTransitionModal = () => {
    setRegionTransitionModal(!regionTransitionModal);
    const fetchTransitions = async () => {
      try {
        const response = await axios.get('https://adminsuvari.stechomeyazilim.info:8765/getBolgeGecisUcretleri/select');
        const mappedTransitions = response.data.map(transition => {
          const source = users.find(u => u.ID === transition.KaynakBolgeID);
          const target = users.find(u => u.ID === transition.HedefBolgeID);
          return {
            id: transition.ID,
            source: source ? source.BolgeAdi : 'Bilinmiyor',
            target: target ? target.BolgeAdi : 'Bilinmiyor',
            fee: transition.Ucret,
            KaynakBolgeID: transition.KaynakBolgeID,
            HedefBolgeID: transition.HedefBolgeID,
          };
        });
        setRegionTransitions(mappedTransitions);
      } catch (error) {
        console.error("Error fetching region transitions:", error);
        setRegionTransitions([]);
      }
    };
    if (users.length > 0) {
      fetchTransitions();
    }
  };


  const handleDefineRegionTransition = async () => {
    if (sourceRegion && targetRegion && transitionFee) {
      const newTransitionData = {
        KaynakBolgeID: sourceRegion.value,
        HedefBolgeID: targetRegion.value,
        Ucret: parseFloat(transitionFee),
      };

      try {
        await axios.post('https://adminsuvari.stechomeyazilim.info:8765/postBolgeGecisUcretleri/send', newTransitionData);
        alert("Bölge geçişi başarıyla tanımlandı!");
        setSourceRegion(null);
        setTargetRegion(null);
        setTransitionFee("");
        toggleRegionTransitionModal();
      } catch (error) {
        console.error("Error defining region transition:", error);
        alert("Bölge geçişi tanımlanırken bir hata oluştu.");
      }
    } else {
      alert("Lütfen tüm alanları doldurun.");
    }
  };

  const fetchRegionTransitions = async () => {
      try {
        const response = await axios.get('https://adminsuvari.stechomeyazilim.info:8765/getBolgeGecisUcretleri/select');
        const mappedTransitions = response.data.map(transition => {
          const source = users.find(u => u.ID === transition.KaynakBolgeID);
          const target = users.find(u => u.ID === transition.HedefBolgeID);
          return {
            id: transition.ID,
            source: source ? source.BolgeAdi : 'Bilinmiyor',
            target: target ? target.BolgeAdi : 'Bilinmiyor',
            fee: transition.Ucret,
            KaynakBolgeID: transition.KaynakBolgeID,
            HedefBolgeID: transition.HedefBolgeID,
          };
        });
        setRegionTransitions(mappedTransitions);
      } catch (error) {
        console.error("Error fetching region transitions:", error);
        setRegionTransitions([]);
      }
    };

  const handleDeleteRegionTransition = async (transitionId) => {
    try {
      await axios.delete(`https://adminsuvari.stechomeyazilim.info:8765/deleteBolgeGecisUcreti/${transitionId}`);
      alert("Bölge geçişi başarıyla silindi.");
      toggleRegionTransitionModal();
      fetchRegionTransitions()
      
    } catch (error) {
      console.error("Error deleting region transition:", error);
      alert("Bölge geçişi silinirken bir hata oluştu.");
    }
  };

  var node = useRef();
  const onPaginationPageChange = (page) => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);
  const onClickDelete = (users) => {
    setContact(users);
    setDeleteModal(true);
  };

  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteJob_Advertisement(contact.ID));
    }
    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  const handleUserClicks = () => {
    setIsEdit(false);
    validation.resetForm();
    toggle();
  };

  const regionOptions = users.map(user => ({ label: user.BolgeAdi, value: user.ID }));

  // Reusable style object for react-select components
  const selectStyles = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      backgroundColor: 'white',
    }),
    menu: (baseStyles, state) => ({
      ...baseStyles,
      backgroundColor: 'white',
    }),
    option: (baseStyles, state) => ({
      ...baseStyles,
      backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
      color: 'black',
    }),
    multiValue: (baseStyles, state) => ({
      ...baseStyles,
      backgroundColor: '#e0e0e0',
    }),
    multiValueLabel: (baseStyles, state) => ({
      ...baseStyles,
      color: 'black',
    }),
  };

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />

      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Bölge Listesi" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-end mb-3">
                    <Button
                      color="info"
                      className="me-2"
                      onClick={toggleRegionTransitionModal}
                    >
                      Bölge Geçişi Tanımla
                    </Button>
                    <Button color="primary" onClick={handleUserClicks}>
                      Yeni Bölge Ekle
                    </Button>
                  </div>

                  <TableContainer
                    columns={columns}
                    data={users}
                    ref={tableRef}
                    isGlobalFilter={true}
                    handleOrderClicks={handleUserClicks}
                    customPageSize={10}
                    className="custom-header-css"
                  />

                  {/* Edit/Add Region Modal */}
                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {!!isEdit ? "Bölge Düzenle" : "Yeni Bölge Ekle"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>
                            <div className="mb-3">
                                <Label htmlFor="BolgeAdi">Bölge Adı</Label>
                                <Input
                                    name="BolgeAdi"
                                    type="text"
                                    placeholder="Bölge Adını Giriniz"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.BolgeAdi}
                                    invalid={
                                        validation.touched.BolgeAdi && validation.errors.BolgeAdi
                                            ? true
                                            : false
                                    }
                                />
                                {validation.touched.BolgeAdi && validation.errors.BolgeAdi ? (
                                    <FormFeedback type="invalid">
                                        {validation.errors.BolgeAdi}
                                    </FormFeedback>
                                ) : null}
                            </div>

                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="text-end mt-3">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Kaydet
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>

                  {/* District/Neighborhood Management Modal */}
                  <Modal isOpen={districtModal} toggle={toggleDistrictModal} size="lg">
                    <ModalHeader toggle={toggleDistrictModal} tag="h4">
                      {selectedRegionForDistrict ? `${selectedRegionForDistrict.BolgeAdi} Bölgesi İlçe Yönetimi` : "İlçe Yönetimi"}
                    </ModalHeader>
                    <ModalBody>
                      <Form>
                        <Row className="mb-3">
                           <Col md={12}>
                              <Label htmlFor="districtSelect">İlçe Seç</Label>
                              <Select
                                id="districtSelect"
                                name="districts"
                                options={istanbulDistricts}
                                className="basic-single-select"
                                classNamePrefix="select"
                                placeholder="İlçe Seçiniz..."
                                value={selectedDistrictForForm}
                                onChange={handleSelectDistrictForForm}
                                styles={selectStyles}
                              />
                            </Col>
                        </Row>
                        {selectedDistrictForForm && ( // Sadece selectedDistrictForForm varsa bu alanları göster
                          <>
                            <Row className="mb-3 mt-3">
                              <Col md={12}>
                                <Label htmlFor="centerNeighborhoodSelect">Merkez Mahalle Seç</Label>
                                <Select
                                  id="centerNeighborhoodSelect"
                                  name="centerNeighborhood"
                                  options={selectedDistrictNeighborhoods}
                                  className="basic-single-select"
                                  classNamePrefix="select"
                                  placeholder="Merkez Mahalleyi Seçiniz..."
                                  value={centerNeighborhood}
                                  onChange={setCenterNeighborhood}
                                  styles={selectStyles}
                                  isDisabled={!selectedDistrictNeighborhoods.length} // Mahalleler yüklenene kadar disabled
                                />
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md={12}>
                                <Label htmlFor="extraFeeInput">Bu Mahalle Dışındakiler Ekstra Ücret (TL)</Label>
                                <Input
                                  id="extraFeeInput"
                                  name="extraFee"
                                  type="number"
                                  placeholder="Ekstra Ücret Giriniz"
                                  value={extraFee}
                                  onChange={(e) => setExtraFee(e.target.value)}
                                />
                              </Col>
                            </Row>
                          </>
                        )}
                        <Row>
                          <Col className="text-end">
                            <Button
                              color="success"
                              onClick={handleAddDistrictWithDetails}
                              disabled={!selectedDistrictForForm || !centerNeighborhood || extraFee === ""}
                            >
                              {isEditDistrictDetails ? "İlçe Detaylarını Düzenle" : "İlçe Detaylarını Kaydet"}
                            </Button>
                            {isEditDistrictDetails && ( // Eğer düzenleme modundaysa "Yeni İlçe Ekle" butonu göster
                              <Button
                                color="light"
                                className="ms-2"
                                onClick={() => {
                                  setSelectedDistrictForForm(null);
                                  setSelectedDistrictNeighborhoods([]);
                                  setCenterNeighborhood(null);
                                  setExtraFee("");
                                  setIsEditDistrictDetails(false); // Ekleme moduna dön
                                }}
                              >
                                Yeni İlçe Ekle
                              </Button>
                            )}
                          </Col>
                        </Row>
                      </Form>
                      <h5 className="mt-4">Eklenen İlçeler:</h5>
                      {associatedDistricts.length === 0 ? (
                        <p>Bu bölgeye henüz ilçe eklenmedi.</p>
                      ) : (
                        <ul className="list-group">
                          {associatedDistricts.map((district) => (
                            <li
                              key={district.value}
                              className="list-group-item d-flex justify-content-between align-items-center"
                              onClick={() => handleEditDistrictFromList(district)} // Tıklama eventi eklendi
                              style={{ cursor: 'pointer' }} // Mouse imleci pointer olacak
                            >
                              <div className="d-flex flex-column flex-grow-1 me-3">
                                <strong>{district.label}</strong>
                                {district.MerkezMahalleAdi && (
                                  <small className="text-muted mt-1">
                                    Merkez Mahalle: {district.MerkezMahalleAdi}
                                  </small>
                                )}
                                {district.MerkezDisiEkUcret !== null && (
                                  <small className="text-muted">
                                    Ekstra Ücret: {parseFloat(district.MerkezDisiEkUcret).toFixed(2)} TL
                                  </small>
                                )}
                              </div>
                              <Button
                                close
                                onClick={(e) => { // Bu butonun tıklanma olayını durdur, li'nin olayını tetiklemesin
                                  e.stopPropagation();
                                  handleRemoveDistrict(district.value);
                                }}
                              >
                                <span aria-hidden="true">&times;</span>
                              </Button>
                            </li>
                          ))}
                        </ul>
                      )}
                    </ModalBody>
                  </Modal>

                  {/* Region Transition Definition Modal */}
                  <Modal isOpen={regionTransitionModal} toggle={toggleRegionTransitionModal}>
                    <ModalHeader toggle={toggleRegionTransitionModal} tag="h4">
                      Bölge Geçişi Tanımla
                    </ModalHeader>
                    <ModalBody>
                      <Form>
                        <div className="mb-3">
                          <Label htmlFor="sourceRegionSelect">Kaynak Bölge</Label>
                          <Select
                            id="sourceRegionSelect"
                            name="sourceRegion"
                            options={regionOptions}
                            styles={selectStyles}
                            classNamePrefix="select"
                            placeholder="Kaynak Bölgeyi Seçiniz..."
                            value={sourceRegion}
                            onChange={setSourceRegion}
                          />
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="targetRegionSelect">Hedef Bölge</Label>
                          <Select
                            id="targetRegionSelect"
                            name="targetRegion"
                            styles={selectStyles}
                            options={regionOptions}
                            classNamePrefix="select"
                            placeholder="Hedef Bölgeyi Seçiniz..."
                            value={targetRegion}
                            onChange={setTargetRegion}
                          />
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="transitionFee">Ücret (TL)</Label>
                          <Input
                            id="transitionFee"
                            name="transitionFee"
                            type="number"
                            placeholder="Geçiş Ücretini Giriniz"
                            value={transitionFee}
                            onChange={(e) => setTransitionFee(e.target.value)}
                          />
                        </div>
                        <div className="text-end">
                          <Button color="success" onClick={handleDefineRegionTransition}>
                            Geçişi Kaydet
                          </Button>
                        </div>
                      </Form>
                      <h5 className="mt-4">Tanımlı Bölge Geçişleri:</h5>
                      {regionTransitions.length === 0 ? (
                        <p>Henüz bir bölge geçişi tanımlanmadı.</p>
                      ) : (
                        <ul className="list-group">
                          {regionTransitions.map((transition) => (
                            <li key={transition.id} className="list-group-item d-flex justify-content-between align-items-center">
                              {transition.source} ➝ {transition.target}: {transition.fee} TL
                              <Button
                                close
                                onClick={() => handleDeleteRegionTransition(transition.id)}
                              >
                                <span aria-hidden="true">&times;</span>
                              </Button>
                            </li>
                          ))}
                        </ul>
                      )}
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);